export enum filterType {
    GOALS = 'Goals',
    CHANNELS = 'Channels',
}
